/**
 * Ce que fait « GO ! » sur la carte du prochain live — la part pure du geste, testée.
 *
 * Port de `bannerGoAnswer` (`student/activity/todo/bannerGoAnswer.js`), lu au moment du toucher
 * sur le jour du live (`liveDayFromToday`) — jamais sur un rendu, qu'un écran resté ouvert la nuit
 * garde figé. Le paiement en attente passe avant tout (`NextLiveSessionBanner.js:400-403`).
 *
 * La branche « bandeau de Sam » du legacy n'a pas lieu d'être : la mission a sa carte et son
 * bouton, « GO ! » ne parle que du live. Un « GO ! » pressé le jour du live fait donc entrer, même
 * si la carte de la mission était restée affichée depuis la veille.
 */
import { LIVE_DAY } from "../../../../../../data/utility/liveDay"

export const LIVE_GO = Object.freeze({
    /** Le paiement est en attente : la boîte de régularisation. */
    PAYMENT_BLOCKED: "payment_blocked",
    /** Le jour du live : `pre-call`. */
    JOIN_LIVE: "join_live",
    /** Pas le jour du live d'après ce qui est chargé : relire le compte, puis répondre à nouveau. */
    RELOAD: "reload",
    /** Le live est un autre jour : la boîte qui le dit. */
    REFUSE: "refuse",
    /** Les données disent un live passé, même relues : rien. */
    NOTHING: "nothing",
} as const)

export type LiveGoAnswer = (typeof LIVE_GO)[keyof typeof LIVE_GO]

export function liveGoAnswer(args: {
    /** `LIVE_DAY.*` du live, ou `null` sans date. */
    liveDay: string | null
    paymentBlocked: boolean
    /** Une relecture est encore permise (le premier toucher) ; après elle, on répond. */
    canReload: boolean
}): LiveGoAnswer {
    const { liveDay, paymentBlocked, canReload } = args
    if (paymentBlocked) return LIVE_GO.PAYMENT_BLOCKED
    if (liveDay === LIVE_DAY.TODAY) return LIVE_GO.JOIN_LIVE
    if (canReload) return LIVE_GO.RELOAD
    return liveDay === LIVE_DAY.FUTURE ? LIVE_GO.REFUSE : LIVE_GO.NOTHING
}
